module.exports = __webpack_public_path__ + "img/iStock-931042070.66bc4ae9.jpg";